<div class="whatsapp-paywall-container">
  <div class="container">
    <div class="row">
      <div class="col-lg-10 offset-lg-1">
        <!-- Cabeçalho -->
        <div class="paywall-header text-center">
          <div class="header-icon">
            <i class="fab fa-whatsapp"></i>
          </div>
          <h2 class="mt-4">Integração com WhatsApp Oficial para seu Negócio</h2>
          <p class="lead mb-0">Conecte-se diretamente com seus clientes através da integração oficial do WhatsApp Business.</p>
        </div>

        <!-- Banner de destaque -->
        <div class="highlight-banner">
          <div class="row align-items-center">
            <div class="col-md-4 text-center text-md-left">
              <img src="/assets/fidelidade/ilustra-whatsapp.svg" alt="WhatsApp Business" class="img-fluid highlight-image">
            </div>
            <div class="col-md-8">
              <div class="highlight-list">
                <div class="highlight-item">
                  <i class="fas fa-check-circle"></i>
                  <span>COMECE AGORA MESMO</span>
                </div>
                <div class="highlight-item">
                  <i class="fas fa-check-circle"></i>
                  <span>30 DIAS GRATUITOS</span>
                </div>
                <div class="highlight-item">
                  <i class="fas fa-check-circle"></i>
                  <span>SEM COMPROMISSO</span>
                </div>
              </div>
              <div class="cta-button-large">
                <button class="btn btn-primary btn-lg btn-block" (click)="iniciarTrialGratis()" [disabled]="loading">
                  <i class="fab fa-whatsapp mr-2" [class.fa-spin]="loading"></i>
                  <span *ngIf="!loading">QUERO TESTAR GRÁTIS E BLINDAR MEU NÚMERO</span>
                  <span *ngIf="loading">ATIVANDO TRIAL...</span>
                </button>
                <p class="cta-subtitle text-center">✓ 30 DIAS SEM CUSTO ALGUM</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Banner de Coexistência - ATUALIZADO -->
        <div class="coexistence-banner">
          <div class="coexistence-icon">
            <i class="fas fa-plus-circle pulse-animation"></i>
          </div>
          <div class="coexistence-content">
            <h4><span class="highlight-text">Novidade:</span> O Melhor dos Dois Mundos!</h4>
            <p>Com nossa <strong>exclusiva integração de coexistência</strong>, você continua usando o WhatsApp Web/Business normalmente <strong>E</strong> adiciona todos os recursos da API oficial no mesmo número. <span class="highlight-text">Não é uma substituição, é uma ampliação das suas possibilidades!</span></p>
          </div>
        </div>

         <!-- Benefícios e Preço - ATUALIZADO -->
         <div class="benefits-pricing-section">
          <div class="row">
            <div class="col-md-7">
              <div class="benefits-card">
                <h4>BENEFÍCIOS EXCLUSIVOS</h4>
                <ul class="benefits-list">
                  <li>
                    <i class="fas fa-server highlight-icon"></i>
                    <div>
                      <h6>Funciona 24h sem Computador</h6>
                      <p>Mensagens enviadas mesmo com o computador desligado, diretamente da nuvem</p>
                    </div>
                  </li>
                  <li>
                    <i class="fas fa-hand-pointer highlight-icon"></i>
                    <div>
                      <h6>Botões Interativos para Respostas</h6>
                      <p>Seus clientes respondem com um clique, aumentando a taxa de conversão</p>
                    </div>
                  </li>
                  <li class="featured-benefit">
                    <i class="fas fa-shield-alt highlight-icon"></i>
                    <div>
                      <h6>PROTEJA SEU NÚMERO CONTRA BANIMENTOS</h6>
                      <p>Integração oficial homologada pela Meta, eliminando o risco de bloqueio do seu número</p>
                    </div>
                  </li>
                  <li>
                    <i class="fas fa-sync-alt highlight-icon"></i>
                    <div>
                      <h6>Use os Dois Simultaneamente</h6>
                      <p>Continue usando o WhatsApp Web/Business enquanto aproveita os recursos avançados</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-5">
              <div class="pricing-card">
                <div class="trial-badge">
                  <span>30 DIAS GRÁTIS</span>
                </div>
                <div class="cta-container">
                  <button class="btn btn-primary btn-lg btn-block" (click)="iniciarTrialGratis()" [disabled]="loading">
                    <i class="fab fa-whatsapp mr-2" [class.fa-spin]="loading"></i>
                    <span *ngIf="!loading">QUERO TESTAR GRÁTIS E BLINDAR MEU NÚMERO</span>
                    <span *ngIf="loading">ATIVANDO TRIAL...</span>
                  </button>
                  <p class="price-info">
                    Após o período gratuito: <strong>R$50/mês</strong>
                    <span class="cancel-anytime">Cancele quando quiser</span>
                  </p>
                </div>
                <ul class="pricing-features">
                  <li class="featured-item"><i class="fas fa-check"></i> <strong>Acesso ilimitado a todos recursos</strong></li>
                  <li class="featured-item"><i class="fas fa-check"></i> <strong>Suporte prioritário</strong></li>
                  <li class="featured-item"><i class="fas fa-check"></i> <strong>Sem taxa de instalação</strong></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabela Comparativa Reformulada - ATUALIZADA -->
        <div class="comparison-section">
          <h4 class="comparison-title">O que você ganha com a Integração Oficial:</h4>
          
          <!-- Exemplo de botão interativo -->
          <div class="interactive-button-example">
            <h5>Exemplo de botão interativo no WhatsApp:</h5>
            <div class="whatsapp-example">
              <div class="chat-container">
                <div class="client-message">
                  <p>Oi, quero fazer um pedido</p>
                  <span class="message-time">01:16</span>
                </div>
                <div class="store-message">
                  <div class="message-title">Ver Cardápio</div>
                  <p>Oi Fulano,</p>
                  <p>Para fazer um pedido acesse o cardápio digital.</p>
                  <div class="action-button">
                    <i class="fas fa-external-link-alt"></i> Fazer Pedido
                    <span class="button-time">01:17</span>
                  </div>
                </div>
              </div>
              <p class="example-caption">Os clientes podem fazer pedidos com apenas um clique, sem precisar digitar!</p>
            </div>
          </div>
          
          <div class="comparison-table">
            <div class="comparison-row header-row">
              <div class="comparison-cell feature-cell">Funcionalidade</div>
              <div class="comparison-cell">O que você já tem<br><small>(WhatsApp Web)</small></div>
              <div class="comparison-cell api-cell">O que você ganha a mais<br><small>(API Oficial)</small></div>
            </div>
            
            <div class="comparison-row">
              <div class="comparison-cell feature-cell">Vários atendentes por número</div>
              <div class="comparison-cell"><i class="fas fa-check-circle check-icon"></i></div>
              <div class="comparison-cell api-cell"><i class="fas fa-check-circle check-icon"></i></div>
            </div>
            
            <div class="comparison-row">
              <div class="comparison-cell feature-cell">Status, grupos, lista de transmissão</div>
              <div class="comparison-cell"><i class="fas fa-check-circle check-icon"></i></div>
              <div class="comparison-cell api-cell"><span class="complement-note">Continua disponível via WhatsApp Web</span></div>
            </div>
            
            <div class="comparison-row highlighted-row">
              <div class="comparison-cell feature-cell">Mensagens com botões interativos</div>
              <div class="comparison-cell"><i class="fas fa-times-circle x-icon"></i></div>
              <div class="comparison-cell api-cell"><i class="fas fa-rocket plus-icon"></i> <span class="new-feature">EXCLUSIVO!</span></div>
            </div>
            
            <div class="comparison-row highlighted-row">
              <div class="comparison-cell feature-cell">Funciona sem computador ligado 24/7</div>
              <div class="comparison-cell"><i class="fas fa-times-circle x-icon"></i></div>
              <div class="comparison-cell api-cell"><i class="fas fa-rocket plus-icon"></i> <span class="new-feature">EXCLUSIVO!</span></div>
            </div>
            
            <div class="comparison-row">
              <div class="comparison-cell feature-cell">Estabilidade e escala para alto volume</div>
              <div class="comparison-cell"><i class="fas fa-times-circle x-icon"></i></div>
              <div class="comparison-cell api-cell"><i class="fas fa-rocket plus-icon"></i> <span class="new-feature">NOVO!</span></div>
            </div>
            
            <div class="comparison-row">
              <div class="comparison-cell feature-cell">Proteção contra bloqueio de número</div>
              <div class="comparison-cell"><i class="fas fa-times-circle x-icon"></i></div>
              <div class="comparison-cell api-cell"><i class="fas fa-rocket plus-icon"></i> <span class="new-feature">NOVO!</span></div>
            </div>
            
            <div class="comparison-row">
              <div class="comparison-cell feature-cell">Selo de verificação (conta verificada) <br><small>(Depende da Meta)</small></div>
              <div class="comparison-cell"><i class="fas fa-times-circle x-icon"></i></div>
              <div class="comparison-cell api-cell"><i class="fas fa-rocket plus-icon"></i> <span class="new-feature">NOVO!</span></div>
            </div>
          </div>
          
          <div class="ban-protection-notice">
            <i class="fas fa-shield-alt pulse-slow"></i>
            <p>A integração oficial com a API do WhatsApp Business <strong>complementa</strong> sua solução atual, adicionando recursos exclusivos como mensagens interativas com botões e funcionamento 24/7 na nuvem, enquanto você mantém todas as funcionalidades que já utiliza no WhatsApp Web/Business.</p>
          </div>
          
          <!-- Botão CTA adicional -->
          <div class="comparison-cta">
            <button class="btn btn-primary btn-lg" (click)="iniciarTrialGratis()" [disabled]="loading">
              <i class="fab fa-whatsapp mr-2" [class.fa-spin]="loading"></i>
              <span *ngIf="!loading">QUERO TESTAR GRÁTIS E BLINDAR MEU NÚMERO</span>
              <span *ngIf="loading">ATIVANDO TRIAL...</span>
            </button>
          </div>
        </div>

        <!-- Depoimento -->
        <div class="testimonial-section">
          <div class="testimonial-card">
            <div class="testimonial-icon">
              <i class="fas fa-quote-right"></i>
            </div>
            <p class="testimonial-text">
              "<strong>Após integrar o WhatsApp Oficial com nossa solução, conseguimos automatizar 70% dos atendimentos 🤖 e aumentamos nossas vendas em 30% 📈. A comunicação com nossos clientes nunca foi tão eficiente! ✨ Além disso, não precisamos mais ligar o computador para enviar mensagens 💻✅, e as vendas aumentaram significativamente com os botões de 'Fazer Pedido' direto na mensagem. 🛒💰</strong>"
            </p>
            <div class="testimonial-author">
              <span class="author-name">Restaurante Oliveira</span>
              <span class="author-location">São Paulo/SP</span>
            </div>
          </div>
        </div>

        <!-- Nota de rodapé -->
        <div class="footer-note">
          <div class="payment-info">
            <i class="fas fa-coins"></i>
            <div class="payment-info-content">
              <h6>Informação sobre cobranças:</h6>
              <p>A API oficial do WhatsApp <strong>não cobra por mensagens recebidas</strong> de seus clientes. Porém, mensagens promocionais ou de marketing enviadas através da API são cobradas separadamente pela Meta e exigem cadastro de pagamento na plataforma Meta Business.</p>
            </div>
          </div>
          
          <div class="footer-cta">
            <button class="btn btn-primary btn-block btn-lg" (click)="iniciarTrialGratis()" [disabled]="loading">
              <i class="fas fa-rocket mr-2" [class.fa-spin]="loading"></i>
              <span *ngIf="!loading">QUERO TESTAR GRÁTIS E BLINDAR MEU NÚMERO</span>
              <span *ngIf="loading">ATIVANDO...</span>
            </button>
          </div>

          <div class="alert alert-info" role="alert">
            <i class="fas fa-info-circle mr-2"></i>
            Ative agora mesmo e aproveite todos os recursos sem espera, já integrado à sua conta atual.
          </div>
          
          <p class="text-center mt-3">
            <a href="javascript:void(0)" (click)="contatarSuporte()">
              Precisa de ajuda? Fale com nosso suporte
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div> 